import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Certifications.css";

const certifications = [
  {
    id: 1,
    title: "Graphic Design Graduate",
    org: "Code to Inspire",
    year: "2024",
    iconClass: "fa-solid fa-paintbrush",
    image: process.env.PUBLIC_URL + "/images/cert7.jpg.jpg",
    description:
      "Completed a professional design course focusing on branding, digital illustration, and creative tools like Adobe Photoshop, Illustrator, and CorelDRAW.",
  },
  {
    id: 2,
    title: "Aspire Leaders Program",
    org: "Harvard-incubated program",
    year: "2025",
    iconClass: "fa-solid fa-users-gear",
    image: process.env.PUBLIC_URL + "/images/cert9.jpg.jpg",
    description:
      "Global leadership program designed to enhance communication, critical thinking, and collaboration with international peers.",
  },
  {
    id: 3,
    title: "Participation Certificate",
    org: "International Computer Science Competition (ICSC)",
    year: "2025",
    iconClass: "fa-solid fa-layer-group",
    image: process.env.PUBLIC_URL + "/images/cert15.jpg.jpg",
    description:
      "Recognized for successfully participating in the 2025 Qualification Round of the International Computer Science Competition, an international event for outstanding computer science students.",
  },

  {
    id: 8,
    title: "Internship Program",
    org: "Nobel Learning PBC",
    year: "2025",
    iconClass: "fa-solid fa-lightbulb",
    image: process.env.PUBLIC_URL + "/images/cert6.jpg.jpg",
    description:
      "Participated in a youth leadership initiative promoting innovation, AI awareness,entrepreneurship, Leadership, Edu Quest and facilitating.",
  },
];

const Certifications = () => {
  const [selected, setSelected] = useState(null);

  return (
    <section className="certifications" id="certifications">
      <h2>
        My <span>Certifications</span>
      </h2>

      <div className="cert-grid">
        {certifications.map((cert) => (
          <div className="cert-card" key={cert.id}>
            <div className="cert-icon">
              <i className={cert.iconClass}></i>
            </div>
            <h3>{cert.title}</h3>
            <p>{cert.org}</p>
            <button className="view-btn" onClick={() => setSelected(cert)}>
              View Certificate
            </button>
          </div>
        ))}
      </div>

      {/* ✅ Glass glowing button */}
      <div className="see-more-container">
        <Link to="/certifications/more" className="see-more-btn glass-btn">
          See More Certificates →
        </Link>
      </div>

      {selected && (
        <div className="popup" onClick={() => setSelected(null)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-x" onClick={() => setSelected(null)}>
              <i className="fa-solid fa-xmark"></i>
            </button>
            <img src={selected.image} alt={selected.title} />
            <h3>{selected.title}</h3>
            <p className="popup-org">
              {selected.org} — {selected.year}
            </p>
            <p className="popup-desc">{selected.description}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Certifications;
